import { createSlice } from '@reduxjs/toolkit'
import { normalizeCinemaId } from 'global/helpers/cinemaList'

const cinemaSelectSlice = createSlice({
    name: 'cinemaSelect',
    initialState: {
        isOpen: false,
        pendingRequests: 0,
    },
    reducers: {
        openCinemaSelect(state) {
            state.isOpen = true
            state.pendingRequests += 1
        },
        confirmCinemaSelect(state, action) {
            if (normalizeCinemaId(action.payload)) state.isOpen = false
        },
        finishCinemaSelect(state) {
            state.pendingRequests = Math.max(0, state.pendingRequests - 1)
            if (!state.pendingRequests) state.isOpen = false
        },
    },
})

const { actions, reducer } = cinemaSelectSlice

export const { openCinemaSelect, confirmCinemaSelect, finishCinemaSelect } = actions

export default reducer
